// @flow
import type { List } from 'immutable';

export default (groups: List<Object>, id: string) => {
    for (let i = 0; i < groups.size; i++) {
        // $FlowFixMe
        const device = groups
            .get(i)
            .get('items')
            .find(device => device.get('id') === id);
        if (device) {
            return `${i}:${device.get('position')}`;
        }
    }
};



// WEBPACK FOOTER //
// ./src/core/state/dashboard/dashboardItemPositionById.js